<template>
  <div>
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('prodfile_edit')">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-file-powerpoint</v-icon>{{ item['name'] }}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-prodfile-show">
      <v-row>
        <v-col md="4">
          <ImageView  :item="item" height="400" width="400" filter="400x400" :edit="userHasAccess('prodfile_edit')"  />
        </v-col>
        <v-col md="8">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>

          <tbody>
            <tr>

              <td><strong>{{ $t('global.name') }}</strong></td>
              <td>
                                    {{ item['name'] }}
              </td>
              <td><strong>{{ $t('prodfile.gcode') }}</strong></td>
              <td>
                                    <v-btn
                                         v-if="item['file']"
                                         color="secondary"
                                         class=""
                                         @click="downloadFile(item['original_name'])"
                                       >
                                         {{ $t('global.download') }}
                                         <v-icon
                                           right
                                           dark
                                         >mdi-download
                                         </v-icon>
                                       </v-btn>
              </td>
            </tr>

            <tr>
              <td><strong>{{ $t('prodfile.designfile') }}</strong></td>
              <td>
                <v-btn
                     v-if="item['designFile']"
                     color="secondary"
                     class=""
                     @click="showHandlerLink(item['designFile'])"
                   >
                     {{ item['designFile'].name }}
                     <v-icon
                       right
                       dark
                     >mdi-eye
                     </v-icon>
                   </v-btn>
              </td>
              <td><strong>{{ $t('machine.machine') }}</strong></td>
              <td>
                                  <span v-if="item['machine']">{{ item['machine'].name }}</span>
              </td>
            </tr>

            <tr>
              <td><strong>{{ $t('tool.tool') }}</strong></td>
              <td>
                                    <span v-if="item['tool']">{{ item['tool'].name }}</span>
              </td>

              <td><strong>{{ $t('printingsurface.printingsurface') }}</strong></td>
              <td>
                                    <span v-if="item['surface']">{{ item['surface'].name }}</span>
              </td>
            </tr>

            <tr>
              <td><strong>{{ $t('material.material') }}</strong></td>
              <td>
                                    <span v-if="item['material']">{{ item['material'].name }}</span>
              </td>

              <td><strong>{{ $t('nozzle.nozzle') }}</strong></td>
              <td>
                                    <span v-if="item['nozzle']">{{ item['nozzle'].name }}</span>
              </td>
            </tr>

            <tr>
              <td><strong>{{ $t('prodfile.quantity') }}</strong></td>
              <td>
                {{ $n(item['quantity']) }}              </td>

              <td><strong>{{ $t('prodfile.timeexecution') }}</strong></td>
              <td>
                {{ $n(item['timeExecution']) }}              </td>
            </tr>

            <tr>
              <td><strong>{{ $t('prodfile.materialconsumed') }}</strong></td>
              <td>
                {{ $n(item['materialConsumed']) }}           </td>
              <td><strong>{{ $t('prodfile.layerHeight') }}</strong></td>
              <td>
                {{ $n(item['layerHeight']) }}              </td>
            </tr>

            <tr>
              <td><strong>{{ $t('global.createdat') }}</strong></td>
              <td>
                {{ formatDateTime(item['created'], 'long') }}              </td>
                <td><strong>{{ $t('global.createdby') }}</strong></td>
                <td>
                  <span v-if="item['createdBy']">{{ item['createdBy'].login }}</span>
                </td>

            </tr>
            <tr>
              <td><strong>{{ $t('global.updatedat') }}</strong></td>
              <td>
                {{ formatDateTime(item['updated'], 'long') }}              </td>
              <td><strong>{{ $t('global.updatedby') }}</strong></td>
              <td>
                <span v-if="item['updatedBy']">{{ item['updatedBy'].login }}</span>
              </td>
            </tr>
          <tr>
            <td colspan="1"><strong>{{$t('prodfile.comment')}}</strong></td>
            <td colspan="3" >
              <span v-if="item.comment">{{item.comment}}</span>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-col>
  </v-row>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';
import FileMixin from '../../mixins/FileMixin';
import ImageView from '../../components/ImageView';
const servicePrefix = 'ProdFile';

export default {
  name: 'ProdFileShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar,
      ImageView
  },
  mixins: [ShowMixin,AccessMixin,FileMixin],
  computed: {
    ...mapFields('prodfile', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('prodfile', ['find'])
  },
  methods: {
    ...mapActions('prodfile', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    }),

  },
};
</script>
